<template>
  <div class="flex-1 flex flex-col">

    <!-- Add Service Centre Modal -->
    <AppModal v-model="showAddServiceCentre" title="Add Service Centre" hide-footer>
      <div class="p-4">
        <form @submit.prevent="saveServiceCentre" class="space-y-4">
          <div class="flex flex-col gap-1">
            <label class="text-xs font-semibold text-gray-600 uppercase tracking-wide">Service Centre Name</label>
            <input type="text" v-model="form.name" placeholder="Service Centre Name" required
                   class="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary bg-gray-50" />
          </div>
          <div class="flex flex-col gap-1">
            <label class="text-xs font-semibold text-gray-600 uppercase tracking-wide">Branch Type</label>
            <select v-model="form.branchType"
                    class="w-full px-3 py-2 text-sm border border-gray-300 rounded-md bg-gray-50 focus:outline-none focus:ring-2 focus:ring-primary">
              <option v-for="option in branchTypeOptions" :key="option.value" :value="option.value">{{
                  option.text
                }}
              </option>
            </select>
          </div>
          <div class="flex flex-col gap-1">
            <label class="text-xs font-semibold text-gray-600 uppercase tracking-wide">Address</label>
            <input type="text" v-model="form.address" placeholder="Address" required
                   class="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary bg-gray-50" />
          </div>
          <div class="grid grid-cols-2 gap-3">
            <div class="flex flex-col gap-1">
              <label class="text-xs font-semibold text-gray-600 uppercase tracking-wide">Latitude</label>
              <input type="number" v-model="form.latitude" step="any" placeholder="Latitude"
                     class="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary bg-gray-50" />
            </div>
            <div class="flex flex-col gap-1">
              <label class="text-xs font-semibold text-gray-600 uppercase tracking-wide">Longitude</label>
              <input type="number" v-model="form.longitude" step="any" placeholder="Longitude"
                     class="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary bg-gray-50" />
            </div>
          </div>
          <div class="flex flex-col gap-1">
            <label class="text-xs font-semibold text-gray-600 uppercase tracking-wide">Phone Number</label>
            <input type="text" v-model="form.phoneNumber" placeholder="Phone Number" required
                   class="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary bg-gray-50" />
          </div>
          <div class="border-t border-gray-100 pt-2 flex justify-end">
            <button type="submit" class="btn-primary" :disabled="loading">
              <i class="fa fa-save mr-1"></i>
              <span v-if="!loading">Save</span>
              <span v-else>Saving...</span>
            </button>
          </div>
        </form>
      </div>
    </AppModal>

    <!-- Edit Service Centre Modal -->
    <AppModal v-model="showEditServiceCentre" title="Edit Service Centre" hide-footer>
      <div class="p-4">
        <form @submit.prevent="updateServiceCentre" class="space-y-4">
          <div class="flex flex-col gap-1">
            <label class="text-xs font-semibold text-gray-600 uppercase tracking-wide">Service Centre Name</label>
            <input type="text" v-model="editForm.name" placeholder="Service Centre Name" required
                   class="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary bg-gray-50" />
          </div>
          <div class="flex flex-col gap-1">
            <label class="text-xs font-semibold text-gray-600 uppercase tracking-wide">Branch Type</label>
            <select v-model="editForm.branchType"
                    class="w-full px-3 py-2 text-sm border border-gray-300 rounded-md bg-gray-50 focus:outline-none focus:ring-2 focus:ring-primary">
              <option v-for="option in branchTypeOptions" :key="option.value" :value="option.value">{{
                  option.text
                }}
              </option>
            </select>
          </div>
          <div class="flex flex-col gap-1">
            <label class="text-xs font-semibold text-gray-600 uppercase tracking-wide">Address</label>
            <input type="text" v-model="editForm.address" placeholder="Address" required
                   class="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary bg-gray-50" />
          </div>
          <div class="grid grid-cols-2 gap-3">
            <div class="flex flex-col gap-1">
              <label class="text-xs font-semibold text-gray-600 uppercase tracking-wide">Latitude</label>
              <input type="number" v-model="editForm.latitude" step="any" placeholder="Latitude"
                     class="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary bg-gray-50" />
            </div>
            <div class="flex flex-col gap-1">
              <label class="text-xs font-semibold text-gray-600 uppercase tracking-wide">Longitude</label>
              <input type="number" v-model="editForm.longitude" step="any" placeholder="Longitude"
                     class="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary bg-gray-50" />
            </div>
          </div>
          <div class="flex flex-col gap-1">
            <label class="text-xs font-semibold text-gray-600 uppercase tracking-wide">Phone Number</label>
            <input type="text" v-model="editForm.phoneNumber" placeholder="Phone Number" required
                   class="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary bg-gray-50" />
          </div>
          <p class="text-xs text-gray-400 italic">This action will be logged against your account.</p>
          <div class="border-t border-gray-100 pt-2 flex justify-end">
            <button type="submit" class="btn-primary" :disabled="loading">
              <i class="fa fa-save mr-1"></i>
              <span v-if="!loading">Save Changes</span>
              <span v-else>Saving...</span>
            </button>
          </div>
        </form>
      </div>
    </AppModal>

    <!-- Toggle Status Modal -->
    <AppModal v-model="showDeleteServiceCentre"
              :title="selectedCentre && selectedCentre.active ? 'Deactivate Service Centre' : 'Activate Service Centre'"
              hide-footer>
      <div class="p-4 space-y-4">
        <p class="text-sm text-gray-600" v-if="selectedCentre && selectedCentre.active">
          Are you sure you want to deactivate this service centre? It will be unavailable for mobile app users.
        </p>
        <p class="text-sm text-gray-600" v-else>
          Are you sure you want to activate this service centre? It will become available for mobile app users.
        </p>
        <div class="flex justify-end">
          <button
            type="button"
            @click="toggleServiceCentreStatus"
            :class="selectedCentre && selectedCentre.active ? 'btn-sm-danger' : 'btn-sm-primary'"
            :disabled="loading"
          >
            <span v-if="selectedCentre && selectedCentre.active">Yes, Deactivate</span>
            <span v-else>Yes, Activate</span>
          </button>
        </div>
      </div>
    </AppModal>

    <!-- Action Bar -->
    <div class="flex items-center justify-end gap-3 mb-4">
      <select v-model="statusFilter" @change="fetchServiceCentres"
              class="px-3 py-2 text-sm border border-gray-300 rounded-md bg-gray-50 focus:outline-none focus:ring-2 focus:ring-primary">
        <option v-for="option in statusOptions" :key="option.value" :value="option.value">{{ option.text }}</option>
      </select>
      <button class="btn-primary" @click="openAddForm">
        <i class="fa fa-plus"></i> Add Service Centre
      </button>
    </div>

    <!-- Table -->
    <div class="bg-white rounded border border-gray-200 overflow-hidden">
      <div v-if="loading && serviceCentres.length === 0" class="py-10 text-center text-sm text-gray-400">
        Loading service centres...
      </div>
      <table v-else class="min-w-full leading-normal">
        <thead>
        <tr class="border-b border-t border-gray-200">
          <th class="t-header">#</th>
          <th class="t-header">Name</th>
          <th class="t-header">Branch Type</th>
          <th class="t-header">Address</th>
          <th class="t-header">Coordinates</th>
          <th class="t-header">Phone Number</th>
          <th class="t-header">Status</th>
          <th class="t-header text-center">Actions</th>
        </tr>
        </thead>
        <tbody>
        <tr :class="[(idx%2) ? rows.even : rows.odd]" v-for="(centre, idx) in serviceCentres" :key="centre.id">
          <td class="t-body">{{ idx + 1 }}</td>
          <td class="t-body font-semibold">{{ centre.name }}</td>
          <td class="t-body capitalize">{{ centre.branchType }}</td>
          <td class="t-body">{{ centre.address }}</td>
          <td class="t-body">{{ centre.latitude }}, {{ centre.longitude }}</td>
          <td class="t-body">{{ centre.phoneNumber }}</td>
          <td class="t-body">
            <span class="text-green-600 font-medium text-xs" v-if="centre.active">Active</span>
            <span class="text-red-500 font-medium text-xs" v-else>Inactive</span>
          </td>
          <td class="t-body">
            <div class="flex gap-2">
              <button @click="openEditForm(centre)" class="btn-sm-primary" title="Edit">
                <i class="fa fa-pencil"></i>
              </button>
              <button @click="openDeleteForm(centre)" :class="centre.active ? 'btn-sm-danger' : 'btn-sm-primary'"
                      :title="centre.active ? 'Deactivate' : 'Activate'">
                <i :class="centre.active ? 'fa fa-ban' : 'fa fa-check'"></i>
              </button>
            </div>
          </td>
        </tr>
        <tr v-if="serviceCentres.length === 0">
          <td colspan="8" class="text-center py-6 text-sm text-gray-400">No service centres found</td>
        </tr>
        </tbody>
      </table>
    </div>

  </div>
</template>

<script>
import AppModal from "@/components/ui/AppModal.vue";
import { api } from "@/app/services/api.service.ts";
import { useToast } from "@/composables";
import { extractErrorMessage } from "@/domains/home/services/configurations/views/mobile/mobileApiUtils";

function extractSuccessMessage(response, fallback) {
  const message = response?.data?.message;
  return message && String(message).trim() ? String(message) : fallback;
}

function unwrapList(body) {
  if (Array.isArray(body)) return body;
  if (body != null && typeof body === "object" && Array.isArray(body.data)) return body.data;
  return [];
}

export default {
  name: "ServiceCentres",
  components: { AppModal },
  setup() {
    const { successToast, errorToast } = useToast();
    return { successToast, errorToast };
  },
  data() {
    return {
      showAddServiceCentre: false,
      showEditServiceCentre: false,
      showDeleteServiceCentre: false,
      loading: false,
      statusFilter: "active",
      rows: {
        odd: "border-t border-gray-200 hover:bg-gray-10",
        even: "border-t border-gray-200 bg-gray-10"
      },
      form: {
        name: "",
        branchType: "MAIN",
        address: "",
        latitude: "",
        longitude: "",
        phoneNumber: ""
      },
      editForm: {
        id: null,
        name: "",
        branchType: "MAIN",
        address: "",
        latitude: "",
        longitude: "",
        phoneNumber: ""
      },
      selectedCentre: null,
      statusOptions: [
        { value: "active", text: "Active" },
        { value: "inactive", text: "Inactive" }
      ],
      branchTypeOptions: [
        { value: "MAIN", text: "Main" },
        { value: "REGIONAL", text: "Regional" },
        { value: "SERVICE_POINT", text: "Service Point" }
      ],
      serviceCentres: []
    };
  },
  async mounted() {
    await this.fetchServiceCentres();
  },
  methods: {
    async fetchServiceCentres() {
      this.loading = true;
      try {
        const url = `/configuration/service-centres?isActive=${this.statusFilter === "active"}`;
        const response = await api().get(url);
        this.serviceCentres = unwrapList(response.data);
      } catch (error) {
        this.errorToast("Error", extractErrorMessage(error, "Error fetching service centres"));
      } finally {
        this.loading = false;
      }
    },
    openAddForm() {
      this.resetForm();
      this.showAddServiceCentre = true;
    },
    openEditForm(centre) {
      this.editForm = { ...centre };
      this.showEditServiceCentre = true;
    },
    openDeleteForm(centre) {
      this.selectedCentre = centre;
      this.showDeleteServiceCentre = true;
    },
    resetForm() {
      this.form = { name: "", branchType: "MAIN", address: "", latitude: "", longitude: "", phoneNumber: "" };
    },
    async saveServiceCentre() {
      this.loading = true;
      try {
        const response = await api().post("/configuration/service-centres", {
          name: this.form.name,
          branchType: this.form.branchType,
          address: this.form.address,
          latitude: this.form.latitude,
          longitude: this.form.longitude,
          phoneNumber: this.form.phoneNumber
        });
        this.successToast("Success", extractSuccessMessage(response, "Service centre added successfully"));
        this.showAddServiceCentre = false;
        this.resetForm();
        await this.fetchServiceCentres();
      } catch (error) {
        this.errorToast("Error", extractErrorMessage(error, "Error adding service centre"));
      } finally {
        this.loading = false;
      }
    },
    async updateServiceCentre() {
      this.loading = true;
      try {
        const response = await api().put(`/configuration/service-centres/${this.editForm.id}`, {
          name: this.editForm.name,
          branchType: this.editForm.branchType,
          address: this.editForm.address,
          latitude: this.editForm.latitude,
          longitude: this.editForm.longitude,
          phoneNumber: this.editForm.phoneNumber
        });
        this.successToast("Success", extractSuccessMessage(response, "Service centre updated successfully"));
        this.showEditServiceCentre = false;
        await this.fetchServiceCentres();
      } catch (error) {
        this.errorToast("Error", extractErrorMessage(error, "Error updating service centre"));
      } finally {
        this.loading = false;
      }
    },
    async toggleServiceCentreStatus() {
      this.loading = true;
      try {
        const response = await api().post(`/configuration/service-centres/${this.selectedCentre.id}/toggle-status`);
        const action = this.selectedCentre.active ? "deactivated" : "activated";
        this.successToast("Success", extractSuccessMessage(response, `Service centre ${action} successfully`));
        this.showDeleteServiceCentre = false;
        this.selectedCentre = null;
        await this.fetchServiceCentres();
      } catch (error) {
        this.errorToast("Error", extractErrorMessage(error, "Error updating service centre status"));
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>
